<!--页面部分-->
<template>
    <div class="OperationLog">
        <!--数据部分-->
        <div class="centerStructure">
            <!--检索条件-->
            <div class="searchBox">
                <span>模块名称：</span>
                <select-tree
                        v-show="true"
                        ref="selectTree"
                        width="140px"
                        :nodeId="selectTreeNodeId"
                        :sourceData="selectTreeData"
                        :formatTreeData="jsonSelectTree"
                        :disabled="isSelectTreeDisabled"
                        :clearable="true"
                        @getValueMethod="clickSelectTree"
                        @getNode="getSelectTreeNode"
                        @clearMethod="clearSelectTree">
                </select-tree>
                <span class="inp">操作类型：</span>
                <el-select filterable v-model="searchForm.operationType" placeholder="操作类型">
                    <el-option class="wh140"
                               v-for="item in searchForm.operationTypeOption"
                               :key="item.id"
                               :label="item.dictionaryName"
                               :value="item.id">
                    </el-option>
                </el-select>
                <span class="inp">执行状态：</span>
                <el-select filterable v-model="searchForm.executionStatus" placeholder="执行状态">
                    <el-option class="wh140"
                               v-for="item in searchForm.executionStatusOption"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
                <span class="inp">操作时间：</span>
                <el-date-picker
                        v-model="searchForm.dateValue"
                        value-format="timestamp"
                        type="datetimerange"
                        :default-time="['00:00:00','23:59:59']"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        size="small"
                >
                </el-date-picker>
                <search-dialog @doSearch="searchButton" @doAdvsearch="advanceSearch"
                >
                    <ul>
                        <li>
                            <span>操作IP：</span>
                            <el-input v-model.trim="searchForm.clientIp" placeholder="操作IP" clearable></el-input>
                        </li>
                        <li>
                            <span>操作人：</span>
                            <el-select filterable v-model="searchForm.operator" placeholder="操作人">
                                <el-option class="wh140"
                                           v-for="item in searchForm.operatorOption"
                                           :key="item.id"
                                           :label="item.userName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </search-dialog>
            </div>
            <!--表格数据-->
            <el-table
                    :data="operationLogTableData"
                    border
                    ref="singleTable"
                    style="width: 100%"
                    height="calc(100% - 84px)">
                <el-table-column fixed header-align="center" type="index" align="center" width="50"></el-table-column>
                <el-table-column prop="operation"
                                 label="详情"
                                 width="60px"
                                 align="center"
                                 header-align="center">
                    <template slot-scope="scope">
                        <span class="tableicon"><i @click="operationLogInfoButton(scope)"
                                                   class="el-icon-view"></i></span>
                    </template>
                </el-table-column>

                <template v-for="item in operationLogTableTitle">
                    <el-table-column
                            :align="item.align"
                            :header-align="item.halign"
                            :key="item.index"
                            :label="item.label"
                            :prop="item.prop"
                            :width="item.width"
                            :formatter="item.formatter"
                            v-if="item.prop !== 'operation'"
                            show-overflow-tooltip>
                    </el-table-column>
                </template>
            </el-table>
            <!--分页数据-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
            </el-pagination>
            <!--弹窗-->
            <el-dialog
                    :title="popupTitle"
                    :visible.sync="openFlag"
                    :close-on-click-modal="false"
                    :modal-append-to-body="false"
                    width="1020px"
                    height="350px"
                    @close="closeDialog"
            >
                <div class="formbox">
                    <el-form
                            :model="operationLogForm"
                            ref="ruleForm"
                            :label-position="labelPosition"
                            label-width="100px"
                    >
                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="模块名称：" prop="modelName">
                                        <el-input class="wh200" v-model="operationLogForm.moduleName"
                                                  disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="操作类型：" prop="operationType">
                                        <el-input class="wh200" v-model="operationLogForm.operationType"
                                                  disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col :span="8">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="端口号：" prop="clientPort">
                                        <el-input class="wh200" v-model="operationLogForm.clientPort"
                                                  disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="操作人：" prop="operator">
                                        <el-input class="wh200" v-model="operationLogForm.operator" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col :span="8">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="操作时间：" prop="operationTime">
                                        <el-input class="wh200" v-model="operationLogForm.operationTime"
                                                  disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="操作IP：" prop="operationIP">
                                        <el-input class="wh200" v-model="operationLogForm.clientIp" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="执行状态：" prop="executionStatus">
                                        <el-radio-group class="wh200" v-model="operationLogForm.executionStatus"
                                                        disabled>
                                            <el-radio border :label=true>成功</el-radio>
                                            <el-radio border :label=false>失败</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="16">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="用户代理：" prop="userAgent">
                                        <el-input style="width: 528px;" v-model="operationLogForm.userAgent"
                                                  disabled></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="textareaUp">
                            <el-col :span="24">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="操作内容：">
                                        <pre class="content">{{operationLogForm.operationContent}}</pre>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="grid-content bg-purple-light">
                                    <el-form-item label="返回内容：">
                                        <pre class="content return">{{operationLogForm.returnContent}}</pre>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-dialog>
        </div>

    </div>
</template>
<!--JS部分-->
<script>
    import {Mixins} from '@/config/mixins/mixins'
    import {$http} from '@/config/api/axios'
    import SearchDialog from '@/components/custom/Searchdialog'
    import SelectTree from "@/components/common/SelectTree";

    export default {
        name: "operationLog",
        mixins: [Mixins],  //混入公共方法,慎用.
        components: {
            SearchDialog,  //引入高级查询弹窗
            SelectTree, //下拉树
        },

        data() {

            return {

                //下拉树相关
                selectTreeNodeId: '',//默认传null
                selectTreeData: [], //树的数据
                jsonSelectTree: [],
                isSelectTreeDisabled: false, //是否可编辑
                selectTreeNode: '',


                //检索条件
                searchForm: {
                    clientIp: '',  //客户端ip
                    moduleName: 0,    //模块名称
                    modelNameOption: [], //模块名称下拉框
                    operationType: 0, //模块类型
                    operationTypeOption: [], //模块类型下拉框
                    executionStatus: '',//执行状态
                    executionStatusOption: [{
                        id: '',
                        name: '全部'
                    }, {
                        id: true,
                        name: '成功'
                    }, {
                        id: false,
                        name: '失败'
                    }],//执行状态下拉框
                    operator: 0, //操作人
                    operatorOption: [], //操作人下拉框
                    startTime: '', //开始时间
                    endTime: '', //结束时间
                    dateValue: '',//日期值
                },
                //操作日志表格数据
                operationLogTableData: [],
                //操作日志表头
                operationLogTableTitle: [
                    {prop: "moduleName", label: '模块名称', width: '120px', align: 'left', halign: 'center', show: true,},
                    {
                        prop: "operationType",
                        label: '操作类型',
                        width: '120px',
                        align: 'center',
                        halign: 'center',
                        show: true,
                    },
                    {prop: "clientIp", label: '操作IP', width: '150px', align: 'center', halign: 'center', show: true,},
                    {prop: "clientPort", label: '端口号', width: '110px', align: 'center', halign: 'center', show: true,},
                    {prop: "operator", label: '操作人', width: '100px', align: 'center', halign: 'center', show: true,},
                    {prop: "loginName", label: '操作人账号', width: '120px', align: 'center', halign: 'center', show: true,},
                    {
                        prop: "operationDateTime",
                        label: '操作时间',
                        width: '160px',
                        align: 'center',
                        show: true,
                    },
                    {
                        prop: "executionStatus",
                        label: '执行状态',
                        width: '120px',
                        align: 'center',
                        halign: 'center',
                        show: true,
                        formatter: function (row) {
                            let returnValue = "";
                            if (row.executionStatus == true) {
                                returnValue = '成功';
                            } else if (row.executionStatus == false) {
                                returnValue = '失败'
                            }
                            return returnValue;
                        }
                    },
                    {prop: "userAgent", label: '用户代理', width: '', align: 'center', halign: 'center', show: true,},
                    /*   {prop: "operation", label: '操作', width: '60px', align: 'center', show: true},*/
                ],

                //弹窗部分
                popupTitle: '操作日志信息',
                //窗体打开标志
                openFlag: false,
                //表单域标签的位置，值为 left 或者 right 时，则需要设置 label-width
                labelPosition: 'right',
                //表单
                operationLogForm: {
                    moduleName: '',
                    operationType: '',
                    operator: '',
                    clientIp: '',
                    proxyIP: '', //代理ip
                    clientPort: '', //端口号
                    operationTime: '',
                    userAgent: '', //用户代理
                    operationContent: '', //操作内容
                    executionStatus: '',//执行状态
                    returnContent: '' //返回内容
                },

                //分页数据
                pageSize: 20, //条数
                pageNumber: 1,
                pageTotal: 0, //总页数
            }
        },

        //监听部分
        watch: {},
        //方法部分
        methods: {
            //删除树(点击clearable)
            clearSelectTree() {
                this.selectTreeNodeId = '';
            },
            //查询下拉树
            getSelectTree() {
                $http("get", "module/listModulesForCustomer").then(
                    (result) => {
                        if (result.status === 'SUCCESS') {
                            this.selectTreeData = result.data;
                        } else {
                            this.msgerror(res.message);
                        }
                    }
                );
                this.jsonSelectTree = {
                    id: "id",
                    label: "moduleName",
                    pcode: "parentCode",
                    code: "moduleCode",
                    nodetype: "moduleTypeId",
                };
            },
            //选中下拉树节点
            getSelectTreeNode(node) {
                this.selectTreeNode = node.data;
            },
            //点击下拉树
            clickSelectTree(data) {
                if (data.code.length <= 3) {
                    this.msgwarning("请选择具体功能点。");
                    return;
                }
                this.$refs.selectTree.setLabel(data.label);
                this.selectTreeNode = data;
                this.selectTreeNodeId = data.id;
            },
            //弹窗取消按钮
            resetForm(ref) {
                this.openFlag = false;
                this.closeDialog();
            },
            //关闭弹窗
            closeDialog() {
                this.$refs['ruleForm'].resetFields(); //清空表单
            },
            //查询按钮
            searchButton() {
                this.handleCurrentChange(1);
            },
            //高级查询
            advanceSearch() {
                this.handleCurrentChange(1);
            },
            //查询操作日志列表
            getOperationLogList() {
                this.operationLogTableData = [];
                this.selfLoadingOpen('.OperationLog');
                let _this = this;
                if (this.searchForm.dateValue !== "" && this.searchForm.dateValue != null) {
                    this.searchForm.startTime = Math.floor(this.searchForm.dateValue[0] / 1000);
                    this.searchForm.endTime = Math.ceil(this.searchForm.dateValue[1] / 1000)
                } else {
                    this.searchForm.startTime = null;
                    this.searchForm.endTime = null;
                }
                let operationType = "";
                let operator = "";
                let executionStatus = "";
                if (this.searchForm.operationType === 0) {
                    operationType = "";
                } else {
                    operationType = this.searchForm.operationType;
                }
                if (this.searchForm.operator === 0) {
                    operator = "";
                } else {
                    operator = this.searchForm.operator;
                }
                if (this.searchForm.executionStatus !== "") {
                    executionStatus = this.searchForm.executionStatus;
                }
                let params = {};
                params.pageSize = _this.pageSize;
                params.pageNumber = _this.pageNumber;
                params.clientIp = _this.searchForm.clientIp;
                params.modelName = _this.selectTreeNodeId;
                params.operationType = operationType;
                params.executionStatus = executionStatus;
                params.operator = operator;
                params.start = _this.searchForm.startTime;
                params.end = _this.searchForm.endTime;
                $http("get", "operationLog/listOperationLog", params)
                    .then((res) => {
                        if (res.status === 'SUCCESS') {
                            for (let i = 0; i < res.data.length; i++) {
                                this.operationLogTableData.push(res.data[i])
                            }
                            this.pageTotal = res.count;
                        } else if (res.status === 'NORESOURCES') {
                            this.operationLogTableData = [];
                            this.pageTotal = 0;
                        } else {
                            this.msgerror(res.message);
                        }
                        this.selfLoadingClose();
                    });
            },
            //查询操作类型下拉框
            getOperationTypeSelect() {
                let param = {
                    typeId: 1005,
                };
                $http("get", "dictionary/listDictionaryByTypeId", param)
                    .then((res) => {
                        if (res.status === 'SUCCESS') {
                            for (let i = 0; i < res.data.length; i++) {
                                this.searchForm.operationTypeOption.push(res.data[i]);
                            }
                            this.searchForm.operationTypeOption.unshift({"id": 0, "dictionaryName": "全部"});
                        } else {
                            this.msgerror(res.message);
                        }
                    })
            },
            //查询操作人下拉框
            getOperatorSelect() {
                $http("get", "user/getUserUnderLoginCustomer")
                    .then((res) => {
                        if (res.status === 'SUCCESS') {
                            for (let i = 0; i < res.data.length; i++) {
                                this.searchForm.operatorOption.push(res.data[i]);
                            }
                            this.searchForm.operatorOption.unshift({"id": 0, "userName": "全部"});
                        } else {
                            this.msgerror(res.message);
                        }
                    })
            },
            //点击详情按钮
            operationLogInfoButton(scope) {
                let param = {};
                param.operationId = scope.row.id;
                $http("get", "operationLog/getOperationLogInfo", param)
                    .then((res) => {
                        if (res.status === 'SUCCESS') {
                            this.operationLogForm.operationType = res.data.operationType;
                            this.operationLogForm.operator = res.data.operator;
                            this.operationLogForm.proxyIP = res.data.proxyIP;
                            this.operationLogForm.clientPort = res.data.clientPort;
                            this.operationLogForm.operationTime = res.data.operationDateTime;
                            this.operationLogForm.moduleName = res.data.moduleName;
                            this.operationLogForm.userAgent = res.data.userAgent;
                            this.operationLogForm.clientIp = res.data.clientIp;
                            let str = JSON.parse(res.data.content);
                            this.operationLogForm.operationContent = JSON.stringify(str, null, 4);
                            this.operationLogForm.executionStatus = res.data.executionStatus;
                            this.operationLogForm.returnContent = res.data.returnContent;
                            this.openFlag = true; //打开弹窗
                        } else {
                            this.msgerror(res.message);
                        }
                    });

            },
            //切换页面方法
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.getOperationLogList();
            },
        },
        //初始化页面执行方法
        created: function () {
            this.getSelectTree();
            this.getOperationLogList(); //初始化调用查询操作日志列表方法
            this.getOperationTypeSelect();
            this.getOperatorSelect();
        },
        activated() {
            if (!!this.$refs['singleTable']) {
                this.$refs.singleTable.doLayout();
            }
        },
    }
</script>
<!--css部分-->
<style lang="less">
    .OperationLog {
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        display: flex;
        position: relative;

        .userAgentWidth {
            width: 520px;
        }

        .userAgentheight {
            height: 250px;
        }

        .content {
            height: 250px;
            overflow: auto;
            width: 853px;
            border: 1px solid #DCDFE6;
            margin: 0;
        }

        .return {
            height: 100px;
        }

        .searchBox {
            display: flex;

            .inp {
                line-height: 32px;
            }

            .el-date-editor.el-range-editor {
                width: 355px;
            }
        }
        .textareaUp{
            height: 272px;
            overflow: hidden;
        }
    }


</style>